import { createTheme } from "@mui/material";
import { agcColours } from "../helpers/colourHelper";

const mainPalette = {
  type: 'light',
  primary: {
    contrastText: '#ffffff',
    main: agcColours.AgrecalcGreen,
  },
  secondary: {
    main: '#d5eeed',
    dark: '#6AC2BF',
    light: '#F4FBFA',
    contrastText: '#EAF6F6',
  },
  text: {
    primary: agcColours.PrussianBlue,
    secondary: agcColours.AgrecalcGreen,
  },
};

export const mainTheme = createTheme(
  {
    palette: mainPalette,
    typography: {
      tablecaption: {
        fontSize: '.65rem',
      },
      fontFamily: [
        'Montserrat'
      ].join(','),
    },
    agc: {
      text: {
        benchmarks: {
          low: '#C94D49',
          medium: '#EDA710',
          high: '#5ACE5D'
        }
      }
    },
    components: {
      MuiDateCalendar: {
      styleOverrides: {
        root: {
          color: agcColours.PrussianBlue,
          borderRadius: '6px',
          border: '1px solid',
          backgroundColor: agcColours.PrussianBlue90
        },
        
      }
    },
      MuiGrid: {
        styleOverrides: {
          root: {
            '&.deactivated': {
              pointerEvents: "none",
              opacity: .85
            },
            '&.activated': {
              pointerEvents: "all",
              opacity: 1
            }
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '.95rem',
            lineHeight: 1.25
          },
          '&.activated': {
            pointerEvents: "all",
            opacity: 1
          }
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            backgroundColor: mainPalette.primary.contrastText,
            color: mainPalette.primary.main
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            boxShadow: 'none'
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '.75rem',
            fontWeight: 'bold',
            lineHeight: 1.25,
            padding: '2px 8px',
            textAlign: 'center',
            borderStyle: 'solid',
            borderColor: mainPalette.primary.contrastText,
            borderWidth: 2,
            height: 35,
            '& .MuiSvgIcon-root': {
              color: agcColours.PrussianBlue,
              right: '2px'
            }
          },
          head: {
            padding: '8px 8px',
          },
        },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            margin: 2,
          },
          '&.activated': {
            pointerEvents: "all",
            opacity: 1
          }
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontWeight: '500',
            padding: 0
          },
          input: {
            padding: 0
          },
          '&.activated': {
            pointerEvents: "all",
            opacity: 1
          }
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
            '&.activated': {
              pointerEvents: "all",
              opacity: 1
            }
          },
          outlinedSecondary: {
            color: agcColours.PrussianBlue,
            backgroundColor: mainPalette.secondary.light,
            border: `1px solid ${agcColours.PrussianBlue}`,
            '&:hover': {
              border: `1px solid ${agcColours.PrussianBlue}`,
              backgroundColor: mainPalette.secondary.main
            },
          },
          endIcon: {
            marginLeft: 0,
          },
        },
      },
      MuiSvgIcon: {
        styleOverrides: {
          colorAction: {
            color: agcColours.AgrecalcForestGreen80
          }
        }

      },
      MuiCheckbox: {
        styleOverrides: {
          colorSecondary: {
            color: agcColours.PrussianBlue,
            '&.Mui-checked': {
              color: agcColours.PrussianBlue,
            },
          },
          colorPrimary: {
            '&.Mui-checked': {
              color: mainPalette.primary.contrastText,
            }
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            '&:hover, :focus': {
              backgroundColor: agcColours.AgrecalcGreen60,
              color: agcColours.PrussianBlue,
              fontWeight: 'bold',
            },
            '&.Mui-selected':{
              color: mainPalette.primary.contrastText,
            }
          },
        },
      },
      MuiDayCalendar:{
        styleOverrides:{
          root: {
          '& .MuiDayCalendar-weekDayLabel': {fontWeight: 'bold',}
          }
        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            backgroundColor: mainPalette.primary.contrastText
          },
          root: {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: mainPalette.secondary.dark,
            },
          },
        },
      },
      MuiPopper: {
        styleOverrides: {
          root: {
            "& .MuiPaper-root": {
              backgroundColor: agcColours.PrussianBlue,
              borderRadius: 6,
              color: mainPalette.primary.contrastText
            },
            "& .MuiIconButton-root": {
              "&.MuiPickersCalendarHeader-switchViewButton": {
                color: mainPalette.primary.main
              },
              "&.MuiPickersArrowSwitcher-button": {
                color: mainPalette.primary.main
              },
            },
            '& .MuiTypography-root': {
              '&.MuiDayPicker-weekDayLabel': {
                color: agcColours.AgrecalcTiffanyBlue,
                fontWeight: 700,
              },
            },
            '& .MuiDayPicker-header ': {
              marginBottom: '5px',
              backgroundColor: mainPalette.secondary.dark,
            },
          },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: agcColours.PrussianBlue,
            borderRadius: 6,
            color: mainPalette.primary.contrastText,
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              backgroundColor: agcColours.PrussianBlue,
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
            '& .MuiSvgIcon-root': {
              color: mainPalette.primary.contrastText
            }
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            color: mainPalette.text.primary,
            borderColor: mainPalette.text.primary,
            padding: 0,
            whiteSpace: 'normal',
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          root: {
            color: mainPalette.primary.main,
            minHeight: 40,
            borderBottomColor: mainPalette.primary.main,
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            backgroundColor: 'transparent'
          },
          content: {
            margin: '8px 0'
          }
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            padding: '15px 0 30px',
            borderTop: `1px solid ${agcColours.PrussianBlue}`,
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            border: 'none',
            width: 'inherit'
          },
        },
      },
      MuiListSubheader: {
        styleOverrides: {
          root: {
            top: 56,
            paddingLeft: 0,
            paddingRight: 0
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            paddingLeft: 0,
            paddingRight: 0
          },
        },
      },
      MuiSnackbar: {
        styleOverrides: {
          root: {
            top: '300px !important'
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            variants: [
              {
                props: { variant: 'inputdetails' },
                style: {
                  backgroundColor: agcColours.AgrecalcBarley50pct,
                  color:agcColours.PrussianBlue
                },
              },
            ],
            backgroundColor: agcColours.PrussianBlue
          }
        },

      }
    },
  }
);